import React from 'react';
export const AppContextContext = React.createContext();
export const ServerContext = React.createContext();